import React from 'react';
import { ContainerBase } from '../containers';
import { Typography } from '@/components/common';
import { SplitColorTitle } from '@/components/common/split-color-title';
import Image from 'next/image';

export const OurTeam: React.FC = () => {
	const teamArray = [
		{
			name: 'Anthony M. Christina, Esq.',
			label: 'Anthony M. Christina, Esq.',
			icon: '/img/landing/headshots-team/anthony-christina.png',
		},
		{
			name: 'Christian Levis, Esq.',
			label: 'Christian Levis, Esq.',
			icon: '/img/landing/headshots-team/christian-levis.jpg',
		},
		{
			name: 'Amanda Fiorilla, Esq.',
			label: 'Amanda Fiorilla, Esq.',
			icon: '/img/landing/headshots-team/amanda-fiorilla.png',
		},
	];
	return (
		<ContainerBase className="lg:pb-[60px]">
			<SplitColorTitle
				blackText="Our"
				colorText="Founders"
				className="text-center"
				textSize="headline-48"
			/>
			<Typography
				type="regular-20"
				className="text-center mb-8 lg:mb-14 mt-4 lg:mt-10 max-w-[750px] mx-auto"
			>
				Decades of legal experience and modern tech, helping consumers claim
				what’s theirs.
			</Typography>
			<div className="grid grid-cols-1 lg:grid-cols-3 xl:px-[60px] gap-y-4 lg:gap-y-0">
				{teamArray.map(({ icon, name }, index) => (
					<div
						key={index}
						className="flex flex-row lg:flex-col items-center justify-center gap-x-6 xl:gap-x-0"
					>
						<Image
							src={icon}
							width={300}
							height={304}
							alt={name}
							className="rounded-3xl lg:rounded-[46px] lg:mx-auto w-[180px] h-[183px] lg:w-[250px] lg:h-[250px] xl:w-[300px] xl:h-[304px]"
						/>
						<Typography
							type="semibold-16"
							className="text-center lg:mt-6 text-grey-90 max-w-[150px] lg:max-w-full"
						>
							{name}
						</Typography>
					</div>
				))}
			</div>
		</ContainerBase>
	);
};
